import React, { useState } from 'react';
import useTranslation from 'Hooks/useTranslation';
import { Box, Tab } from '@mui/material';
import { TabContext } from '@mui/lab';
import QuestionsTab from '../../Tabs/Questions';
import ConfigurationTab from '../../Tabs/Configuration';
import { CustomTabsList, CustomTabPanel } from './style';

export default function Tabs({ formData, setFormData, setUnchanged, lessonId }) {
  const [value, setValue] = useState('1');

  const { t2 } = useTranslation('EditCourse');

  if (!formData || formData?.questions?.length === 0) {
    return null;
  }

  const handleOnChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <Box>
        <CustomTabsList onChange={handleOnChange}>
          <Tab value="1" label={t2('Questions')} />
          <Tab value="2" label={t2('Configuration')} />
        </CustomTabsList>
      </Box>
      <CustomTabPanel value="1">
        <QuestionsTab formData={formData} setFormData={setFormData} setUnchanged={setUnchanged} />
      </CustomTabPanel>
      <CustomTabPanel value="2">
        <ConfigurationTab
          formData={formData}
          setFormData={setFormData}
          setUnchanged={setUnchanged}
          lessonId={lessonId}
        />
      </CustomTabPanel>
    </TabContext>
  );
}
